import moment from "moment";
import React, { useMemo } from "react";
import { CALCULATE_NIGHTS_COUNT, FOLIO_FORMAT } from "../../../utils/helper";
import { IoLocationSharp } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { TbWorld } from "react-icons/tb";
import { useSelector } from "react-redux";
import { getCurrentCurrency } from "../../../utils/customCurrencyHelper";
import {
  constructCombinedPriceBreakup,
  requiredRoomInvoiceBreakupFormat,
} from "../../../utils/invoiceHelper";
import useConvertImageToBase64 from "../../../hooks/useConvertImageToBase64";

const NewInvoiceStructure = (props) => {
  const { hotelDetails, hotelContentDetails, base64EncodedHotelLogo } =
    useSelector((store) => store.login);

  const { isMobileScreen } = useSelector((store) => store.appHeader);

  const { banksResponse } = useSelector((store) => store.bank);
  const bankDetails = Array.isArray(banksResponse)
    ? banksResponse?.filter((Obj) => Boolean(Obj?.defaultBankName))?.[0]
    : {};
  const qrCodUrl = bankDetails?.qrCodeUrl;
  const { base64: qrBase64 } = useConvertImageToBase64(qrCodUrl);

  const showBankDataInInvoice = Boolean(hotelDetails?.showBankDetailsInInvoice);

  const cancellationPolicyArray = Array.isArray(
    hotelContentDetails?.cancellationPoliciesText,
  )
    ? hotelContentDetails?.cancellationPoliciesText?.slice(0, 3)
    : [];

  let { checkInTime, checkOutTime, zoneOffset } = hotelDetails;
  const { symbol, position } = getCurrentCurrency(hotelDetails?.currency);

  const isPrint = props?.print;
  const isDownloadPdf = props?.download;
  let targetRef = isPrint ? props?.val : props?.targetRef;
  const isAllInvoice = Boolean(props?.isAllInvoice)
    ? props?.isAllInvoice
    : false;

  const roomInvoice = props?.roomInvoice ?? {};
  const invoiceId = props?.invoiceId;

  const customerObject = props?.customerDetails;
  const bookingObject = props?.bookingDetails;
  const paymentArray = Array.isArray(props?.paymentDetails)
    ? props?.paymentDetails
    : [];

  let isCmIdPresent = Boolean(bookingObject?.cmId);

  let invoiceDetails = props?.invoiceDetails;

  const nightsCount = useMemo(
    () =>
      CALCULATE_NIGHTS_COUNT(
        bookingObject?.checkIn,
        bookingObject?.checkOut,
        hotelDetails,
      ),
    [bookingObject?.checkIn, bookingObject?.checkOut, hotelDetails],
  );

  const invoiceArray = useMemo(
    () =>
      requiredRoomInvoiceBreakupFormat(
        invoiceDetails,
        isCmIdPresent,
        nightsCount ?? 1,
      ),
    [invoiceDetails, isCmIdPresent, nightsCount],
  );

  const roomDetails = props?.roomDetails;

  const posData = props?.posData;

  if (bookingObject?.checkIn) {
    checkInTime = moment(bookingObject?.checkIn)
      .utcOffset(zoneOffset)
      .format("HH:mm");
  }

  if (bookingObject?.checkOut) {
    checkOutTime = moment(bookingObject?.checkOut)
      .utcOffset(zoneOffset)
      .format("HH:mm");
  }

  const bankSection = [
    {
      title: "Account Holder Name",
      value: Boolean(bankDetails?.accountHolderName)
        ? bankDetails?.accountHolderName?.toUpperCase()
        : null,
    },
    {
      title: "Bank Account Number",
      value: Boolean(bankDetails?.accountNumber)
        ? bankDetails?.accountNumber
        : null,
    },
    {
      title: "Bank Name",
      value: Boolean(bankDetails?.bankName)
        ? bankDetails?.bankName?.toUpperCase()
        : null,
    },
    {
      title: "IFSC Code",
      value: Boolean(bankDetails?.ifscCode)
        ? bankDetails?.ifscCode?.toUpperCase()
        : null,
    },
  ];
  let phoneNumber = "";
  if (
    customerObject?.contactDetails &&
    customerObject?.contactDetails?.countryCode
  ) {
    phoneNumber += customerObject?.contactDetails?.countryCode;
  }
  if (
    customerObject?.contactDetails &&
    customerObject?.contactDetails?.phoneNumber
  ) {
    phoneNumber += customerObject?.contactDetails?.phoneNumber;
  }
  const customerSection = [
    {
      title: "Name",
      value: Boolean(customerObject?.name) ? customerObject?.name : null,
    },
    {
      title: "Phone No",
      value: phoneNumber,
    },
    {
      title: "Email",
      value: Boolean(customerObject?.email) ? customerObject?.email : null,
    },
    {
      title: "Company Name",
      value: Boolean(customerObject?.company) ? customerObject?.company : null,
    },
    {
      title: "GSTIN",
      value: Boolean(customerObject?.gstIN) ? customerObject?.gstIN : null,
    },
    {
      title: "Address ",
      value: Boolean(customerObject?.address) ? customerObject?.address : null,
    },
  ];

  const hotelInformation = [
    {
      title: Boolean(hotelDetails && hotelDetails?.name)
        ? hotelDetails?.name
        : null,
      Logo: hotelDetails?.logo,
    },

    {
      title: Boolean(hotelDetails && hotelDetails?.contactNumber)
        ? hotelDetails?.contactNumber
        : null,
      Logo: FaPhoneAlt,
    },

    {
      title: Boolean(hotelDetails && hotelDetails?.website)
        ? hotelDetails?.website
        : null,
      Logo: TbWorld,
    },
    {
      title: Boolean(hotelDetails && hotelDetails?.emailAddress)
        ? hotelDetails?.emailAddress
        : null,
      Logo: MdEmail,
    },
    {
      title: Boolean(hotelDetails && hotelDetails?.address)
        ? hotelDetails?.address?.substring(0, 150)
        : null,
      Logo: IoLocationSharp,
    },
  ];

  let bookingSection = Boolean(
    props?.bookingDetails && Object?.keys(props?.bookingDetails)?.length > 0,
  )
    ? [
        {
          title: "Room No / Plan",
          value: Boolean(roomDetails)
            ? `${roomDetails?.name} X ${roomDetails?.type} / ${bookingObject?.mealPlan}`
            : null,
        },
        {
          title: "Adult-Child",
          value: Boolean(bookingObject?.adults)
            ? `${bookingObject?.adults} - ${bookingObject?.children} `
            : null,
        },
        {
          title: "Check-in/Check-out",
          value: Boolean(bookingObject?.checkIn && bookingObject?.checkOut)
            ? `${moment(bookingObject?.checkIn)?.format(
                "D-MM-YYYY",
              )} | ${moment(bookingObject?.checkOut)?.format("D-MM-YYYY")}`
            : null,
        },
        {
          title: "Booking Source",
          value: Boolean(bookingObject?.source) ? bookingObject?.source : null,
        },
        {
          title: "Source Booking ID",
          value: bookingObject?.companyBookingId,
        },
      ]
    : [];

  let combinedPriceBreakup = [];

  combinedPriceBreakup = constructCombinedPriceBreakup(
    invoiceArray,
    posData,
    nightsCount || 1,
  );

  let paymentReceived = 0;
  let totalBill = 0;
  let totalRefund = 0;
  let balanceDue = 0;
  let discount = 0;
  let subTotal = 0;
  let totalAddons = 0;
  let roundOff = 0;
  let amountSettledInRoomBill = 0;

  invoiceArray?.forEach((Obj) => {
    subTotal += Obj?.subTotal;
    totalBill += Obj?.total;
    discount += Obj?.discount;
    paymentReceived += Obj?.paid;
    totalRefund += Obj?.refund;
    roundOff += Obj?.roundOff ?? 0;
    amountSettledInRoomBill += Obj?.amountSettledInRoomBill ?? 0;
  });

  let addOns = roomInvoice?.priceBreakup?.find((Obj) => Obj?.type === "Addons");

  if (
    addOns &&
    roomInvoice &&
    roomInvoice?.id &&
    invoiceDetails &&
    invoiceDetails.length > 0 &&
    invoiceDetails.map((invD) => invD?.id)?.includes(roomInvoice.id)
  )
    addOns?.addOns?.forEach((Obj) => (totalAddons += +Obj?.price * Obj?.count));

  const onlyPosSummarizedBill =
    roomInvoice &&
    roomInvoice?.id &&
    invoiceDetails &&
    invoiceDetails.length > 0 &&
    !invoiceDetails.map((invD) => invD?.id)?.includes(roomInvoice.id) &&
    props?.isSummarized;

  if (isAllInvoice) {
    paymentReceived = 0;
    totalRefund = 0;

    Array.isArray(paymentArray) &&
      paymentArray
        ?.map((obj) => obj.amount)
        ?.filter((Obj) => Obj < 0)
        .map((obj) => (totalRefund += -obj));

    Array.isArray(paymentArray) &&
      paymentArray
        ?.map((obj) => obj.amount)
        ?.filter((Obj) => Obj > 0)
        .map((obj) => (paymentReceived += obj));
  }

  const priceBreakupHead = onlyPosSummarizedBill
    ? [
        { title: " # Item & Description ", width: "30%" },
        { title: "HSN/SAC", width: "15%" },
        { title: "Rate", width: "11%" },
        { title: "TAX", width: "10%" },
        { title: "TOTAL", width: "10%" },
        { title: "Amount Settled In Room Bill", width: "23%" },
      ]
    : [
        { title: " # Item & Description ", width: "30%" },
        { title: "HSN/SAC", width: "15%" },
        { title: "Rate", width: "11%" },
        { title: "Count", width: "10%" },
        { title: "Discount", width: "13%" },
        { title: "TAX", width: "10%" },
        { title: "TOTAL", width: "10%" },
      ];

  const isSinglePosInvoice =
    invoiceDetails &&
    invoiceDetails?.length == 1 &&
    invoiceDetails[0].invoiceType === "pos";

  balanceDue = FOLIO_FORMAT(totalBill - paymentReceived + totalRefund);

  let currentInvoiceForBillDate = invoiceDetails?.find(
    (Obj) => Obj?.invoiceId === props?.invoiceId,
  );

  const invoiceTitleInformation = [
    {
      title: "TAX INVOICE",
    },
    {
      title: Boolean(invoiceId) ? `#INV-${invoiceId}` : "Tentative",
    },
    {
      title: Boolean(hotelDetails?.gstIN)
        ? `GSTIN: ${hotelDetails?.gstIN}`
        : "",
    },
    {
      title: `Payment Due: ${`${position === "before" ? symbol : ""} ${
        Boolean(balanceDue) ? balanceDue : "00"
      } ${position === "after" ? `${symbol}` : ""}`}`,
    },
    {
      title: Boolean(currentInvoiceForBillDate?.invoiceBilledDate)
        ? moment(currentInvoiceForBillDate?.invoiceBilledDate)?.format(
            "DD MMM, YYYY",
          )
        : "",
    },
  ];

  let hotelLogo = hotelDetails?.logo;

  let posName = Boolean(props?.posObj) ? props?.posObj?.name : "";

  // if summarized feild is present in hotel invoice settings, and we are at the "ALL" tab, then alter the combined array
  if (props?.isSummarized) {
    // first filtering out invoices which are not of type roomBill
    combinedPriceBreakup = combinedPriceBreakup?.filter(
      (obj) => obj.invoiceType == "roomBill",
    );

    props?.invoiceDetails?.forEach((invoice) => {
      const posSacCode = posData?.find(
        (Obj) => Obj?.id === invoice?.posId,
      )?.sac;

      if (invoice?.invoiceType == "pos") {
        let obj = {
          description: Boolean(invoice?.invoiceId) ? invoice?.invoiceId : "-",
          count: "-",
          discount: invoice?.discount ? FOLIO_FORMAT(invoice?.discount) : "-",
          rate: FOLIO_FORMAT(invoice?.subTotal),
          taxRate: FOLIO_FORMAT(invoice?.totalTax),
          amount: FOLIO_FORMAT(invoice?.total),
          hsn: posSacCode,
          amountSettledInRoomBill: FOLIO_FORMAT(
            invoice?.amountSettledInRoomBill,
          ),
        };
        combinedPriceBreakup.push(obj);
      }
    });
  }

  let currentTaxObject = [];

  invoiceArray?.forEach((Obj) => {
    currentTaxObject = [...currentTaxObject, ...(Obj?.taxObjects || [])];
  });

  let updatedTaxObject = [];
  let taxMap = new Map();

  currentTaxObject?.forEach((Obj) => {
    const existingTax = taxMap.get(Obj?.taxName);
    if (existingTax) existingTax.taxAmount += Obj?.taxAmount;
    else taxMap.set(Obj?.taxName, { ...Obj });
  });

  updatedTaxObject = Array.from(taxMap.values());

  let finalTaxObject = updatedTaxObject?.map((Obj) => {
    return {
      title: `${Obj?.taxName} (${Obj?.taxPercentage}%)`,
      value: Obj?.taxAmount,
    };
  });

  let calculationArray = [
    { title: "Amount", value: subTotal + (discount ?? 0) },
    { title: "Discount", value: discount ?? 0 },
    { title: "Sub Total", value: subTotal },
    { title: "Add-ons", value: totalAddons },
    ...finalTaxObject,
  ];
  if (roundOff) {
    calculationArray.push({ title: "Round Off", value: roundOff });
  }
  if (onlyPosSummarizedBill) {
    calculationArray.push({
      title: "Amount Settled In Roomn Bill",
      value: amountSettledInRoomBill,
    });
  }
  calculationArray.push(
    { title: "Total", value: totalBill ?? 0 },
    { title: "Payment Received", value: paymentReceived ?? 0 },
    { title: "Refund", value: totalRefund ?? 0 },
    { title: "Payment Due", value: +balanceDue ?? 0 },
  );

  calculationArray = calculationArray
    ?.filter((Obj) => typeof Obj.value === "number" && !isNaN(Obj.value))
    ?.filter((Obj) => Obj?.value);

  calculationArray = calculationArray.map((Obj, idx) => {
    return { ...Obj, value: Obj.value?.toFixed(2) };
  });

  return (
    <div
      id="invoice"
      className={`p-7 font-system print-content ${
        isDownloadPdf
          ? "w-[210mm] min-h-[297mm] overflow-hidden mx-auto bg-white flex flex-col"
          : "min-h-screen flex flex-col"
      }`}
      ref={targetRef}
    >
      <div className="flex-grow">
        <header className="flex justify-between mb-3">
          <div className="leftSection-hotelInformation flex flex-col gap-1 ">
            {invoiceTitleInformation?.map((Obj, index) => {
              return (
                <div
                  className={`${
                    index === 0
                      ? ` text-[#000] font-[600] ${
                          isMobileScreen ? "text-[15px]" : "text-[23px]"
                        }`
                      : ` text-[#000] font-[500]  ${
                          isMobileScreen ? "text-[9px]" : "text-[15px]"
                        } `
                  } ${
                    index === 3
                      ? "text-[#F36960] font-[600] leading-[16px]"
                      : ""
                  } font-system`}
                >
                  {Obj?.title}
                </div>
              );
            })}

            {posName && (
              <p className="mt-[10px] font-system text-[11px]  text-[#4d4d4d] bg-[#EBEBEB] px-[18px] py-[6px]">{`POS - ${posName}`}</p>
            )}
          </div>

          <div className="rightSection-PaymentTitleInformation flex flex-col items-end w-[45%]">
            {hotelInformation?.map((Obj, index) => {
              return index === 0 ? (
                <div>
                  {Boolean(hotelLogo) && (
                    <div className="w-[76px] h-[75px] rounded-[3px] flex items-center justify-center">
                      <img
                        src={base64EncodedHotelLogo}
                        className="w-full h-full object-cover rounded-[3px]"
                        alt="hotel logo"
                      />
                    </div>
                  )}
                </div>
              ) : index === 1 ? (
                <div className=" flex gap-2 items-center">
                  <div
                    className={` ${
                      isMobileScreen
                        ? "text-[13px]"
                        : "text-[17px] md:text-[19px] "
                    }  text-[#000] font-[700]  leading-[21px]`}
                  >
                    {hotelDetails?.name}
                  </div>
                </div>
              ) : (
                Boolean(Obj?.title) && (
                  <div className="flex gap-3 items-start" key={Obj?.title}>
                    {/* Logo container with conditional margin-top */}
                    <div
                      className={`bg-[#EBEBEB] rounded-full p-[2px] ${
                        isDownloadPdf ? "mt-[8px]" : ""
                      }`}
                    >
                      <Obj.Logo className="text-[#4D4D4D] text-[12px]" />
                    </div>

                    {/* Title text with responsive font size and adjusted text indent */}
                    <div
                      className={`${
                        isMobileScreen ? "text-[9.5px]" : "text-[12px]"
                      } font-system text-[#1A1C21] font-[400] leading-[15px] text-right`}
                      style={{
                        textIndent: isMobileScreen ? "0px" : "-10px", // Adjust negative indent for second line
                        wordWrap: "break-word", // Ensure long words wrap properly
                      }}
                    >
                      {Obj?.title}
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </header>

        <div className="w-[100%] h-[1px] my-[24px] bg-[#EBEBEB] "> </div>

        <section
          className={` ${
            isDownloadPdf ? "mb-4" : ""
          } flex w-[100%] gap-[2rem] ] flex-col justify-center`}
        >
          <div className="billToSection flex flex-col gap-2">
            <div className=" uppercase font-[600] text-[12.5px]  whitespace-nowrap leading-[17.64px] text-[#000]">
              Bill To
            </div>

            <div className="flex w-[100%] ">
              <div className="w-[40%] ">
                {customerSection?.map((Obj, index) => {
                  return (
                    Boolean(Obj?.value) && (
                      <div className="flex flex-col gap-2">
                        <div
                          className={` ${
                            isMobileScreen ? "text-[9px]" : "text-[13px]"
                          } flex gap-2 w-[100%] font-system  leading-[18px]`}
                        >
                          <div
                            className={` font-[500]  w-${customerObject?.company ? "[15ch]" : "[12ch]"} whitespace-nowrap    text-[#000]`}
                          >
                            {Obj?.title?.toUpperCase()} :
                          </div>
                          <div className={`  text-[#000]  font-[500] w-[50%]`}>
                            {Obj?.value}
                          </div>
                        </div>
                      </div>
                    )
                  );
                })}
              </div>

              {bookingSection?.length > 0 && (
                <div className="w-[60%]  flex flex-col ml-auto items-end mr-10">
                  {bookingSection?.map((Obj, index) => {
                    return (
                      Boolean(Obj?.value) && (
                        <div className="flex flex-col gap-2  w-[80%]">
                          <div
                            className={` ${
                              isMobileScreen ? "text-[9px]" : "text-[13px]"
                            } font-system  leading-[18px] flex gap-2 w-[100%] justify-end self-end`}
                          >
                            <div
                              className={` font-[500]  w-[42%] whitespace-nowrap text-[#000]`}
                            >
                              {Obj?.title?.toUpperCase()} :
                            </div>

                            <div className=" font-[500]  w-[30%] text-[#000] break-words whitespace-normal ">
                              {Obj?.value}
                            </div>
                          </div>
                        </div>
                      )
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </section>

        <main className="priceBreakupSection mt-5">
          <div className="flex justify-between items-start bg-[#F6F8FC] w-[100%]  px-4 py-2">
            {priceBreakupHead?.map((Obj, idx) => {
              return (
                <div
                  className={` ${
                    isMobileScreen ? "text-[9px]" : "text-[11px]"
                  }  w-[${Obj?.width}] 
                   font-system font-[600]  leading-tight tracking-wide
              text-[#000] uppercase `}
                >
                  {Obj?.title?.toUpperCase()}
                </div>
              );
            })}
          </div>

          <div className="body w-[100%]">
            {combinedPriceBreakup?.map((Obj, index) => {
              return (
                <div
                  className={` ${
                    isMobileScreen ? "text-[10px]" : "text-[15px]"
                  } flex justify-between px-4 py-2 font-system font-[500] 
                   leading-tight text-[#000]`}
                >
                  <div className="w-[30%]">
                    {index + 1} &nbsp;
                    {Obj?.description}
                    {Obj?.nightsCount && Obj?.nightsCount !== "-" ? (
                      <span className="whitespace-nowrap">
                        {" "}
                        X {Obj?.nightsCount} Nights
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="w-[15%] ">{Obj?.hsn}</div>

                  <div className="w-[11%] pl-1"> {+Obj?.rate}</div>
                  {!onlyPosSummarizedBill ? (
                    <>
                      <div className="w-[10%] pl-2">{Obj?.count}</div>
                      <div className="w-[13%] pl-2">{Obj?.discount}</div>
                      <div className="w-[10%]">{Obj?.taxRate}</div>
                      <div className="w-[10%]">{Obj?.amount}</div>
                    </>
                  ) : (
                    <>
                      <div className="w-[10%]">{Obj?.taxRate}</div>
                      <div className="w-[10%]">{Obj?.amount}</div>
                      <div className="w-[23%]">
                        {Obj?.amountSettledInRoomBill}
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </main>

        <div className="w-full border-t border-gray-500 my-2"></div>

        <div
          className={`calculations w-full flex justify-end pr-[30px] mb-2 avoid-break`}
        >
          <div className="w-[40%]">
            {calculationArray?.map((Obj) => {
              return (
                <div
                  className={` ${
                    isMobileScreen ? "text-[11px]" : "text-[14px]"
                  } flex font-system leading-[12px] 
                text-[#222B45] w-full justify-between mb-[10px]`}
                >
                  <p className="font-[550]">{Obj?.title?.toUpperCase()}</p>
                  <p className="font-[550]">{Obj?.value}</p>
                </div>
              );
            })}
          </div>
        </div>

        {showBankDataInInvoice && bankDetails?.accountNumber && (
          <div className="avoid-break">
            <p className="text-[14px] font-[600] text-[#111827] mb-2">
              Bank Details
            </p>

            <div className="bg-[#F8FAFC] border border-[#E5E7EB] rounded-[8px] p-4 flex justify-between items-start">
              <div className="flex flex-col gap-2 w-[65%]">
                {bankSection?.map(
                  (Obj) =>
                    Boolean(Obj?.value) && (
                      <div className="flex text-[13px] leading-[20px]">
                        <span className="w-[140px] text-[#6B7280]">
                          {Obj.title}
                        </span>

                        <span className="mx-2">:</span>

                        <span className="font-[600] text-[#111827] flex-1">
                          {Obj.value}
                        </span>
                      </div>
                    ),
                )}
              </div>

              <div>
                {Boolean(qrCodUrl) && (
                  <div className="flex flex-col items-center gap-1">
                    <img
                      src={isDownloadPdf ? qrBase64 : qrCodUrl}
                      className="w-[110px] h-[110px] object-contain"
                      alt="Bank QR"
                    />
                    <p className="text-[10px] text-[#6B7280]">Scan to Pay</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="mt-auto avoid-break">
        <div className="mt-4">
          {!isSinglePosInvoice && (
            <p className="font-system text-[#222B45] mb-3 font-[400] leading-[12px] text-[11px]">
              <span className="font-[500]"> Disclaimer:</span> Checkin time{" "}
              {checkInTime} & Checkout time {checkOutTime} | T&C Applied
            </p>
          )}

          <div className="flex flex-col gap-1 mb-3">
            {cancellationPolicyArray?.map((Obj) => {
              return (
                <p className="font-system  font-[500]  leading-tight  text-[10.5px]">
                  {Obj}
                </p>
              );
            })}
          </div>

          <footer id="footer" className="border-t">
            <div>
              <div
                className={` ${
                  isMobileScreen ? "text-[6px]" : "text-[8px]"
                } mb-[5px]`}
              ></div>

              <div
                className={` ${
                  isMobileScreen ? "text-[6px]" : "text-[8px]"
                } grid grid-cols-3 gap-4`}
              >
                <div className="flex items-center">
                  <p className="font-system  font-[500] whitespace-nowrap leading-[10px]">
                    Powered By <span className="text-[#2F80ED]"> Revivo</span>{" "}
                    <span className="text-[#007FFF] "> HOTEL-X</span>
                  </p>
                </div>
                <div>
                  <div>
                    {hotelDetails?.staffSignatureEnabled ? (
                      <div className="flex justify-between mt-3">
                        <div className="flex flex-col items-start">
                          <p className="text-[11px] font-[500] text-[#000]">
                            Guest Signature
                          </p>
                          <div className="w-[200px] h-[40px] border-b border-[#00000050] mt-4"></div>
                        </div>
                        <div className="flex flex-col items-end">
                          <p className="text-[11px] font-[500] text-[#000]">
                            Authorized Signature
                          </p>
                          <div className="w-[200px] h-[40px] border-b border-[#00000050] mt-4"></div>
                        </div>
                      </div>
                    ) : (
                      <p className="text-[#000000B2] whitespace-nowrap font-[400] text-[10px]">
                        This is a computer generated Invoice, No Signature
                        Needed
                      </p>
                    )}
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default NewInvoiceStructure;
